import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import FacilityPage from './facility-page'

const QUERY = gql`
query Facility($id: String!) {
  facility(facility_id: $id) {
    facility_id
    facility_name
    state
    state_name
    city
    zip
    phone
    photo_facility
    course_type_label
    operations_type_label
    address1
    address2
    address3
    address4
    universal_id
  }
}
`

export default function FacilityPageWithData(props) {
  return (
    <Query query={QUERY} variables={props} context={{ clientName: 'pga-algolia' }}>
      {({
        loading, error, data,
      }) => {
        if (error) {
          return <Error error={error} displayErrorType="page" />
        }
        if (loading) return <LinearProgress color="secondary" />
        const response = data.facility

        return response ? (
          <FacilityPage {...props} {...response} />
        ) : <Error statusCode={404} />
      }}
    </Query>
  )
}
